module.exports = __webpack_public_path__ + "img/cases-brand-maxam-lazyload-91.20fc0299.jpg";